import { c as _slicedToArray, f as _asyncToGenerator } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState } from 'react';
import { L as Loading } from './loading-c16d3bd3.js';
import { E as Error } from './error-ee5266a9.js';
import { Select, useResponsiveParams, Paper, Text, Grid, GridItem, InputLookup, Input, NotificationList } from 'quanta-ui';
import { updateFieldUser, updateBusinessLocation, updateIntermediary } from './common/intermediary/state.js';
import { a as GET_FIELDUSER_LIST, b as GET_SELECTED_INTERMEDIARY, C as CHANGE_DEFAULT_INTERMEDIARY, F as FETCH_ROLE, c as LOOKUP_INTERMEDIARY, f as GET_USER_PROFILE_VAR_DETAILS, d as CHECK_IMD_CONFIG, e as GET_SELECTEDIMD_DTLS } from './queries-5a111b86.js';
import { useQuery, useMutation } from '@apollo/client';
import moment from 'moment';
import { M as ModalImdSearch } from './modal-imd-search-7a00d2e1.js';
import './exports-166cdf01.js';
import { a as updateDefaultImdDetails } from './ShortenString-21905b6b.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';

function SelectFieldUser(_ref) {
  var selectedIntermediary = _ref.selectedIntermediary,
      intermediarySelectionDisabled = _ref.intermediarySelectionDisabled;
      _ref.setAlerts;
      _ref.setChooseProducts;

  var _useQuery = useQuery(GET_FIELDUSER_LIST, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        intermediaryCode: selectedIntermediary.intermediaryCode,
        officeId: selectedIntermediary.branchOfficeCode
      }
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (loading) return /*#__PURE__*/React.createElement("div", {
    className: "-ml-12 -mt-8"
  }, /*#__PURE__*/React.createElement(Loading, {
    textSize: "normal",
    className: "flex flex-row justify-center items-center space-x-2 pt-12 text-opacity-50 text-primary w-full"
  }));
  if (error) return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start -ml-16 -mt-8"
  }, /*#__PURE__*/React.createElement(Error, {
    className: "flex flex-row justify-center items-center space-x-2 pt-12 text-base text-opacity-50 text-red-600 w-full"
  }));
  var getFiledUserByIMID = data.getFiledUserByIMID;

  var getFieldUserName = function getFieldUserName(code) {
    return getFiledUserByIMID && code !== '' ? getFiledUserByIMID.find(function (fieldUser) {
      return fieldUser.fieldUserCode === code;
    }).fieldUserName : '';
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
    size: "full",
    value: selectedIntermediary.fieldUserCode,
    data: getFiledUserByIMID.map(function (fieldUser) {
      return {
        label: fieldUser.fieldUserName,
        value: fieldUser.fieldUserCode
      };
    }),
    disabled: intermediarySelectionDisabled ? true : false,
    onChange: function onChange(e) {
      updateFieldUser(e.target.value, getFieldUserName(e.target.value));
    }
  }));
}

function SelectIntermediaryForm(_ref) {
  var _dataRole$checkAuth, _dataRole$checkAuth$r, _myIntermediaries$fin3;

  var myIntermediaries = _ref.myIntermediaries;
      _ref.userMyDetail;
      var userType = _ref.userType,
      intermediarySelectionDisabled = _ref.intermediarySelectionDisabled,
      setAlerts = _ref.setAlerts,
      setChooseProducts = _ref.setChooseProducts,
      isConfigImd = _ref.isConfigImd,
      refetch = _ref.refetch;
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });

  var _useQuery = useQuery(GET_SELECTED_INTERMEDIARY, {
    fetchPolicy: 'cache-first'
  }),
      data = _useQuery.data; // const { userType } = userMyDetail;


  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imdModalDisplay = _useState2[0],
      showImdModal = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchStringImd = _useState4[0],
      setSearchStringImd = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      onDataUpdate = _useState6[0],
      setOnUpdate = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      imdCodeOutput = _useState8[0],
      setImdCodeOutput = _useState8[1];

  var selectedIntermediary = data.selectedIntermediary;

  var _useState9 = useState(selectedIntermediary.intermediaryName),
      _useState10 = _slicedToArray(_useState9, 2),
      imdVal = _useState10[0],
      setImdVal = _useState10[1];

  var _useMutation = useMutation(CHANGE_DEFAULT_INTERMEDIARY),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      changeDefaultIntermediary = _useMutation2[0],
      _useMutation2$ = _useMutation2[1];
      _useMutation2$.loading;
      _useMutation2$.error;

  var getIntermediaryCode = function getIntermediaryCode(Name) {
    var _myIntermediaries$fin2;

    return myIntermediaries ? (_myIntermediaries$fin2 = myIntermediaries.find(function (intermediary) {
      return intermediary.intermediaryName === Name;
    })) === null || _myIntermediaries$fin2 === void 0 ? void 0 : _myIntermediaries$fin2.intermediaryCode : '';
  }; // const{ data: imdLookUpData,} = useQuery(LOOKUP_INTERMEDIARY, {
  //   variables: {
  //     filter: {
  //       imdCode:myIntermediaries?.find((imd) => imd.intermediaryCode
  //       //  === imdCode
  //        )
  //       ?.intermediaryCode   
  //     },
  //     fetchPolicy: 'network-only',
  //   },
  // });


  useFetchQuery();

  var _useQuery2 = useQuery(FETCH_ROLE, {
    fetchPolicy: 'cache-first'
  });
      _useQuery2.loading;
      var dataRole = _useQuery2.data;

  var role = dataRole === null || dataRole === void 0 ? void 0 : (_dataRole$checkAuth = dataRole.checkAuth) === null || _dataRole$checkAuth === void 0 ? void 0 : (_dataRole$checkAuth$r = _dataRole$checkAuth.role) === null || _dataRole$checkAuth$r === void 0 ? void 0 : _dataRole$checkAuth$r.roleName;

  var ImdCheck = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(imdCode) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /*CR169 - Check imd is Utkarsh_Bank Configured or not*/
              refetch(imdCode);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function ImdCheck(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); //const [doImdCheck , loading ] 


  var _useQuery3 = useQuery(LOOKUP_INTERMEDIARY, {
    fetchPolicy: 'cache-first',
    variables: {
      filter: {
        imdCode: myIntermediaries === null || myIntermediaries === void 0 ? void 0 : (_myIntermediaries$fin3 = myIntermediaries.find(function (imd) {
          return imd.intermediaryCode === (selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode);
        })) === null || _myIntermediaries$fin3 === void 0 ? void 0 : _myIntermediaries$fin3.intermediaryCode
      }
    },
    onCompleted: function onCompleted(data) {
      var _data$intermediaryLoo;

      // console.log("data",data);
      if ((data === null || data === void 0 ? void 0 : (_data$intermediaryLoo = data.intermediaryLookup) === null || _data$intermediaryLoo === void 0 ? void 0 : _data$intermediaryLoo.intermediaryEndDate) !== '') {
        var imdEndDate = new Date(moment(data === null || data === void 0 ? void 0 : data.intermediaryLookup.intermediaryEndDate, "DD/MM/YYYY").format('YYYY/MM/DD'));
        var currentDate = new Date(moment().format('YYYY/MM/DD'));

        if (imdEndDate < currentDate) {
          //setDisableS
          setChooseProducts(false);
          setAlerts([{
            header: "License end date is expired",
            id: Date.now(),
            content: /*#__PURE__*/React.createElement("div", {
              className: "flex flex-row flex-wrap space-y-2 w-full h-full"
            }, /*#__PURE__*/React.createElement("span", null, "Intermediary End Date is Expired. Please use a valid Intermediary")),
            type: 'error',
            timeout: null,
            disableClose: false
          }]);
        } else {
          setAlerts([]);
          setChooseProducts(true);
        }
      }
    }
  });
      _useQuery3.loading;
      _useQuery3.error;
      _useQuery3.data1;
      _useQuery3.previousData;

  var getBusinessLocations = function getBusinessLocations(code) {
    var _myIntermediaries$fin4;

    return myIntermediaries && code ? (_myIntermediaries$fin4 = myIntermediaries.find(function (intermediary) {
      return intermediary.intermediaryCode === code;
    })) === null || _myIntermediaries$fin4 === void 0 ? void 0 : _myIntermediaries$fin4.businessLocations : [];
  };

  var getLocationName = function getLocationName(code) {
    var _myIntermediaries$fin5, _businessLocations$fi;

    var businessLocations = (_myIntermediaries$fin5 = myIntermediaries.find(function (intermediary) {
      return intermediary.intermediaryCode === selectedIntermediary.intermediaryCode;
    })) === null || _myIntermediaries$fin5 === void 0 ? void 0 : _myIntermediaries$fin5.businessLocations;
    return businessLocations ? (_businessLocations$fi = businessLocations.find(function (loc) {
      return loc.code === code;
    })) === null || _businessLocations$fi === void 0 ? void 0 : _businessLocations$fi.name : '';
  };

  return /*#__PURE__*/React.createElement("div", {
    className: repeat === 1 ? 'mt-2' : ''
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: repeat === 1 ? 'pt-2' : 'pl-4 pt-2'
  }, /*#__PURE__*/React.createElement(Text, {
    type: "title"
  }, "Choose Partner")), /*#__PURE__*/React.createElement(Grid, {
    repeat: repeat,
    gap: repeat === 1 ? 2 : 16,
    className: "".concat(repeat === 1 ? '' : 'px-4', " pb-4")
  }, /*#__PURE__*/React.createElement(GridItem, null, /*#__PURE__*/React.createElement(Text, {
    type: "label"
  }, "Partner"), /*#__PURE__*/React.createElement(InputLookup, {
    size: "full" // searchable = {true}
    ,
    disabled: intermediarySelectionDisabled || (userType === null || userType === void 0 ? void 0 : userType.typeName.toLowerCase()) === 'field user' ? true : false // disableSelect={false}
    ,
    value: imdVal //{selectedIntermediary.intermediaryCode}
    ,
    onLookup: function onLookup(val, setFieldValue) {
      var _val$toString;

      if ((val === null || val === void 0 ? void 0 : (_val$toString = val.toString()) === null || _val$toString === void 0 ? void 0 : _val$toString.length) > 0) {
        setSearchStringImd(val);
        setOnUpdate(function (_) {
          var newFunc = function newFunc(data) {
            // console.log("2033...data", data)
            //  setImdVal(e?.intermediaryName);
            setImdVal(data.intermediaryName);

            if (getIntermediaryCode(data === null || data === void 0 ? void 0 : data.intermediaryName)) {
              updateIntermediary(data === null || data === void 0 ? void 0 : data.intermediaryCode, data === null || data === void 0 ? void 0 : data.intermediaryName);
              ImdCheck(data === null || data === void 0 ? void 0 : data.intermediaryCode);
              updateBusinessLocation(getBusinessLocations(data === null || data === void 0 ? void 0 : data.intermediaryCode)[0].code, getBusinessLocations(data === null || data === void 0 ? void 0 : data.intermediaryCode)[0].name);
              updateFieldUser('', '');
              changeDefaultIntermediary({
                variables: {
                  input: {
                    imdCode: data === null || data === void 0 ? void 0 : data.intermediaryCode
                  }
                }
              });
              updateDefaultImdDetails(data === null || data === void 0 ? void 0 : data.intermediaryCode); //update in Imd cache
            }
          };

          return newFunc;
        });
        setImdCodeOutput([]);
        showImdModal(true);
      }
    } // data={myIntermediaries.map((imd) => {
    //   return {
    //     label: imd.intermediaryCode,
    //     value: imd.intermediaryName,
    //   };
    // })}

  }), /*#__PURE__*/React.createElement(ModalImdSearch, {
    showImdModal: showImdModal,
    imdModalDisplay: imdModalDisplay,
    searchStringImd: searchStringImd,
    onDataUpdate: onDataUpdate,
    imdCodeOutput: imdCodeOutput,
    setImdCodeOutput: setImdCodeOutput,
    myIntermediaries: myIntermediaries,
    role: role,
    setSearchStringImd: setSearchStringImd
  })), /*#__PURE__*/React.createElement(GridItem, null, /*#__PURE__*/React.createElement(Text, {
    type: "label"
  }, "Business Location"), /*#__PURE__*/React.createElement(Select, {
    size: "full",
    disabled: intermediarySelectionDisabled || (userType === null || userType === void 0 ? void 0 : userType.typeName.toLowerCase()) === 'field user' ? true : false,
    value: selectedIntermediary.branchOfficeCode,
    data: getBusinessLocations(selectedIntermediary.intermediaryCode) ? getBusinessLocations(selectedIntermediary.intermediaryCode).map(function (loc) {
      return {
        label: loc.name,
        value: loc.code
      };
    }) : [],
    onChange: function onChange(e) {
      updateBusinessLocation(e.target.value, getLocationName(e.target.value));
      updateFieldUser('', '');
    }
  })), /*#__PURE__*/React.createElement(GridItem, null, /*#__PURE__*/React.createElement(Text, {
    type: "label"
  }, "Field User"), isConfigImd && /*#__PURE__*/React.createElement(Text, {
    severity: "error"
  }, " *"), (userType === null || userType === void 0 ? void 0 : userType.typeName.toLowerCase()) === 'field user' ? /*#__PURE__*/React.createElement(Input, {
    size: "full",
    disabled: true,
    value: selectedIntermediary.fieldUserName,
    flat: true
  }) : /*#__PURE__*/React.createElement(SelectFieldUser, {
    selectedIntermediary: selectedIntermediary,
    intermediarySelectionDisabled: intermediarySelectionDisabled,
    setAlerts: setAlerts,
    setChooseProducts: setChooseProducts
  })))));
}

function IntermediaryDetails(_ref) {
  var intermediarySelectionDisabled = _ref.intermediarySelectionDisabled,
      setChooseProducts = _ref.setChooseProducts;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      alerts = _useState2[0],
      setAlerts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2);
      _useState4[0];
      var setSkip = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      userMyDtls = _useState6[0],
      setUserMyDtls = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      userType = _useState8[0],
      setUserType = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2);
      _useState10[0];
      _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isConfigImd = _useState12[0],
      setConfigImd = _useState12[1];
  /*GET_USER_PROFILE_VAR_DETAILS - fetch cache profile data */


  var _useQuery = useQuery(GET_USER_PROFILE_VAR_DETAILS, {
    //LOAD_USER_PROFILE, {
    fetchPolicy: 'cache-first',
    // skip: skip,
    onCompleted: function onCompleted(data) {
      var _data$profileData = data.profileData;
          _data$profileData.checkAuth;
          var userMyDetail = _data$profileData.userMyDetail; // const { associatedCoreEntity } = checkAuth.organisation;

      // const { associatedCoreEntity } = checkAuth.organisation;
      var associatedCoreEntity = data.profileData.userMyDetail.organisation.associatedCoreEntity;
      var userType = userMyDetail.userType;
      setUserMyDtls(userMyDetail);
      setUserType(userType);

      if ((userType === null || userType === void 0 ? void 0 : userType.typeName.toLowerCase()) === 'field user') {
        updateFieldUser(associatedCoreEntity.type, associatedCoreEntity.value);
      } else {
        updateFieldUser('', '');
      }

      setSkip(true);
    }
  }),
      profileLoading = _useQuery.loading,
      profileError = _useQuery.error,
      dataUserProfileVar = _useQuery.data;

  var _useQuery2 = useQuery(CHECK_IMD_CONFIG, {
    skip: true,
    fetchPolicy: 'cache-first'
  }),
      imdCheckLoading = _useQuery2.loading,
      imdCheckError = _useQuery2.error;
      _useQuery2.data;
      var _refetch = _useQuery2.refetch;

  var _useQuery3 = useQuery(GET_SELECTEDIMD_DTLS, // GET_INTERMEDIARY_LIST,
  {
    fetchPolicy: 'network-only',
    onCompleted: function () {
      var _onCompleted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _selectedImdDtls$find, _selectedImdDtls$find2, _checkImdConfigdata$c;

        var selectedImdDtls, defaultIntermediary, defaultBusinessLocation, _yield$refetch, checkImdConfigdata;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //const { myIntermediaries } = data;
                selectedImdDtls = data.selectedImdDtls;
                defaultIntermediary = selectedImdDtls === null || selectedImdDtls === void 0 ? void 0 : selectedImdDtls.find(function (imd) {
                  return imd.isSelected;
                });
                defaultBusinessLocation = selectedImdDtls === null || selectedImdDtls === void 0 ? void 0 : (_selectedImdDtls$find = selectedImdDtls.find(function (imd) {
                  return imd.isSelected;
                })) === null || _selectedImdDtls$find === void 0 ? void 0 : _selectedImdDtls$find.businessLocations[0];
                updateIntermediary(defaultIntermediary === null || defaultIntermediary === void 0 ? void 0 : defaultIntermediary.intermediaryCode, defaultIntermediary === null || defaultIntermediary === void 0 ? void 0 : defaultIntermediary.intermediaryName);
                updateBusinessLocation(defaultBusinessLocation === null || defaultBusinessLocation === void 0 ? void 0 : defaultBusinessLocation.code, defaultBusinessLocation === null || defaultBusinessLocation === void 0 ? void 0 : defaultBusinessLocation.name);
                _context.next = 7;
                return _refetch({
                  intermediaryCode: selectedImdDtls === null || selectedImdDtls === void 0 ? void 0 : (_selectedImdDtls$find2 = selectedImdDtls.find(function (imd) {
                    return imd.isSelected;
                  })) === null || _selectedImdDtls$find2 === void 0 ? void 0 : _selectedImdDtls$find2.intermediaryCode
                });

              case 7:
                _yield$refetch = _context.sent;
                checkImdConfigdata = _yield$refetch.data;
                setConfigImd(checkImdConfigdata === null || checkImdConfigdata === void 0 ? void 0 : (_checkImdConfigdata$c = checkImdConfigdata.checkConfigImd) === null || _checkImdConfigdata$c === void 0 ? void 0 : _checkImdConfigdata$c.isConfiguredIMD);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onCompleted(_x) {
        return _onCompleted.apply(this, arguments);
      }

      return onCompleted;
    }()
  }),
      loading = _useQuery3.loading,
      error = _useQuery3.error;
      _useQuery3.data;

  if (loading || profileLoading || imdCheckLoading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error || profileError || imdCheckError) return /*#__PURE__*/React.createElement(Error, null); //const { myIntermediaries } = intermediaryData;

  var intermediaries = dataUserProfileVar.profileData.userMyDetail.organisation.intermediaries; //const { userMyDetail } = profileData;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectIntermediaryForm, {
    myIntermediaries: intermediaries,
    //myIntermediaries
    userMyDetail: userMyDtls,
    userType: userType,
    intermediarySelectionDisabled: intermediarySelectionDisabled,
    setAlerts: setAlerts,
    setChooseProducts: setChooseProducts,
    isConfigImd: isConfigImd,
    refetch: function () {
      var _refetch2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(imdCode) {
        var _checkImdConfigdata$c2;

        var _yield$_refetch, checkImdConfigdata;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _refetch({
                  intermediaryCode: imdCode
                });

              case 2:
                _yield$_refetch = _context2.sent;
                checkImdConfigdata = _yield$_refetch.data;
                setConfigImd(checkImdConfigdata === null || checkImdConfigdata === void 0 ? void 0 : (_checkImdConfigdata$c2 = checkImdConfigdata.checkConfigImd) === null || _checkImdConfigdata$c2 === void 0 ? void 0 : _checkImdConfigdata$c2.isConfiguredIMD);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refetch(_x2) {
        return _refetch2.apply(this, arguments);
      }

      return refetch;
    }()
  }), /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  }));
}

export { IntermediaryDetails as I, SelectFieldUser as S, SelectIntermediaryForm as a };
